// extracted by mini-css-extract-plugin
export default {"table":"theme_table__ICbOB","list":"theme_list__sAsoA","message":"theme_message__6wsJM"};